/*
  surgomed-variant-sync.js

  Keeps variant-specific parts of a product page in step with the selected
  variant. Data comes from snippets/surgomed-variant-data.liquid; templates
  announce changes with a 'surgomed:variant-change' event carrying
  { sectionId, variantId }. Only elements marked for that section update.

  Marked elements: data-variant-section="<section id>" data-variant-field="<field>".
  Values are written as plain text (an <img> gets its src set instead). An element, or its closest
  [data-variant-row], is hidden when the value is empty.
*/
(function () {
  if (window.SurgomedVariantSync) return;

  // Matches Shopify's money format (e.g. $1,085.00) so values don't change
  // format when a customer switches variant.
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function readData(sectionId) {
    var el = document.querySelector('script[data-variant-data="' + sectionId + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fieldValue(v, field) {
    var onSale = v.compare_at && v.compare_at > v.price;
    switch (field) {
      case 'title': return v.title ? v.title.split(' / ').join(' \u00b7 ') : '';
      case 'image': return v.image || '';
      case 'price': return formatMoney(v.price);
      case 'compare_at': return onSale ? formatMoney(v.compare_at) : '';
      case 'save_amount': return onSale ? 'Save ' + formatMoney(v.compare_at - v.price) : '';
      case 'save_percent': return onSale ? '-' + Math.floor((v.compare_at - v.price) * 100 / v.compare_at) + '%' : '';
      default:
        if (field.indexOf('option') === 0) {
          var i = parseInt(field.slice(6), 10);
          return (v.options && v.options[i]) || '';
        }
        return v[field] == null ? '' : String(v[field]);
    }
  }

  function apply(sectionId, variantId) {
    var data = readData(sectionId);
    if (!data || !data.variants) return;
    var v = data.variants[String(variantId)];
    if (!v) return;
    var els = document.querySelectorAll('[data-variant-section="' + sectionId + '"][data-variant-field]');
    for (var n = 0; n < els.length; n++) {
      var el = els[n];
      var val = fieldValue(v, el.getAttribute('data-variant-field'));
      if (el.tagName === 'IMG') {
        if (val) el.src = val;
      } else {
        el.textContent = val;
      }
      var target = el.closest('[data-variant-row]') || el;
      target.hidden = (val === '');
    }
  }

  document.addEventListener('surgomed:variant-change', function (e) {
    if (e && e.detail && e.detail.sectionId && e.detail.variantId) {
      apply(e.detail.sectionId, e.detail.variantId);
    }
  });

  window.SurgomedVariantSync = { apply: apply };
})();
